module.exports = __webpack_public_path__ + "img/Bulk.715edbe4.svg";